import React, { useRef, useContext } from "react";
import Popover from "../";
import s from "styled-components";
import PT from "prop-types";
import CheckmarkIcon from "_c/icon/Checkmark";
import Label from "_c/form/Label";
import TextInput from "_c/form/TextInput";
import { Button } from "_c/button";
import { ThemeContext } from "styled-components";

const StyledForm = s.form`
 padding: 5px;
 text-align: left;
`;
const InputRow = s.div`
 display: flex;
 align-items: center;
 input {
  flex: 1;
  width: 125px;
 }
 span {
  font-weight: 700;
  margin-left: 7px;
  color: var(--color-primary);
 }
`;
const Form = (props) => {
  const inputRef = useRef();
  const onSubmit = (e) => {
    e.preventDefault();
    const value = Number(inputRef.current.value);
    props.onSubmit(value || 1);
    props.popoverRef.current.hideTooltip();
  };
  const acceptLabel = props.t("common:accept");
  return (
    <StyledForm onSubmit={onSubmit}>
      <div>
        <Label theme={props.theme} htmlFor="basket-unit-picker">
          {props.t("common:choose_amount")}:
        </Label>
        <InputRow>
          <TextInput
            theme={props.theme}
            required
            ref={inputRef}
            type="number"
            id="basket-unit-picker"
            defaultValue={1}
            min={1}
          />
          <span>{props.unitName}</span>
        </InputRow>
      </div>
      <Button
        theme={props.theme}
        small
        withIcon
        type="submit"
        title={acceptLabel}
        style={{ marginTop: "10px" }}
      >
        <CheckmarkIcon color="white" />
        <span>{acceptLabel}</span>
      </Button>
    </StyledForm>
  );
};
const BasketUnitPopover = (props) => {
  const theme = useContext(ThemeContext);
  const ref = useRef();
  return (
    <Popover
      ref={ref}
      content={
        <Form
          t={props.t}
          popoverRef={ref}
          theme={theme}
          onSubmit={props.onSubmit}
          unitName={props.unitName}
        />
      }
    >
      {props.children}
    </Popover>
  );
};
BasketUnitPopover.propTypes = {
  unitName: PT.string.isRequired,
  onSubmit: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default BasketUnitPopover;
